import { ReactNode } from 'react'
import { H3, YStack } from 'tamagui'

interface ISectionCardProps {
  title: string
  children: ReactNode
}

export function SectionCard({ title, children }: ISectionCardProps) {
  return (
    <YStack
      gap="$size.spacing-md"
      backgroundColor="$bg-surface"
      p="$size.spacing-xs"
      br="$border-radius-md"
      borderWidth={1}
      borderColor="$border-default"
      width="100%"
      $gtSm={{ padding: '$size.spacing-md' }}
    >
      <H3 ff="$mulishBold" fontSize="$font-size-sm" color="$text-primary">
        {title}
      </H3>
      {children}
    </YStack>
  )
}
